import { Box, HStack, Skeleton, Stack } from '@chakra-ui/react';

export const SignupFormSkeleton = () => {
  return (
    <Stack spacing="6" data-test="signup-form-skeleton">
      <Stack spacing="6" align="center">
        <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
          {/* Heading skeleton */}
          <Skeleton height={{ base: '20px', md: '24px' }} width="180px" mx="auto" />

          {/* Login link skeleton */}
          <HStack justify="center" spacing="1">
            <Skeleton height="16px" width="140px" />
            <Skeleton height="16px" width="60px" />
          </HStack>
        </Stack>
      </Stack>

      <Box py={{ base: '0', sm: '8' }} px={{ base: '4', sm: '10' }} bg="white">
        {/* Google Sign-in button skeleton */}
        <Skeleton height="40px" width="100%" mb="6" />

        <Stack spacing="6">
          <Stack spacing="5">
            {/* Name field skeleton */}
            <Stack spacing="2">
              <Skeleton height="16px" width="40px" />
              <Skeleton height="40px" width="100%" />
            </Stack>

            {/* Email field skeleton */}
            <Stack spacing="2">
              <Skeleton height="16px" width="40px" />
              <Skeleton height="40px" width="100%" />
            </Stack>

            {/* Password field skeleton */}
            <Stack spacing="2">
              <Skeleton height="16px" width="70px" />
              <Skeleton height="40px" width="100%" />
              <Skeleton height="14px" width="140px" />
            </Stack>
          </Stack>

          {/* Create account button skeleton */}
          <Stack spacing="4">
            <Skeleton height="40px" width="100%" />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default SignupFormSkeleton;
